import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';

const DEFAULT_CLASS = 'btn btn-primary waves-effect waves-light clickable btn-m';
const CREATE =  <FormattedMessage id={'sumbit.create'} defaultMessage={'Create'}/>;
const UPDATE = <FormattedMessage id={'submit.update'} defaultMessage={'Update'}/>;
const UPDATING = <FormattedMessage id={'submit.updating'} defaultMessage={'Updating...'}/>;

class SubmitButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: CREATE
        };
    }

    componentDidMount() {
        if (this.props.isUpdate) {
            this.setState({text: UPDATE})
        }
    }

    render() {

        if (this.props.showSubmitButtonSpinner) {
            return (
                <button disabled type="submit" className={`${DEFAULT_CLASS} disabled`}>
                    <i className="fa fa-spin fa-spinner"/> {UPDATING}
                </button>
            );
        }

        return (
            <button data-cy-submit onClick={this.props.onClick} className={DEFAULT_CLASS} type="submit">
                {this.state.text}
                </button>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        showSubmitButtonSpinner: state.showSubmitButtonSpinner,
    };
}

export default connect(mapStateToProps)(SubmitButton);


// WEBPACK FOOTER //
// ./web/src/components/common/SubmitButton.jsx